import { html, nothing, TemplateResult } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { OutlineCard } from '../../base/outline-card/outline-card';
// import '../ghs-icon/ghs-icon';

import componentStyles from './ghs-infographics-panel.css.lit';
import { LightController } from '../../controllers/light-controller';

/**
 * The infographics Panel component.
 * @element ghs-infographics-panel
 * @slot default - The default slot.
 */
@customElement('ghs-infographics-panel')
export class GhsInfographicsPanel extends OutlineCard {
  static styles = [componentStyles];

  lightController = new LightController(
    this,
    GhsInfographicsPanel.styles,
    this.tagName.toLowerCase()
  );

  @state() hasTitleSlot: boolean;

  firstUpdated(): void {
    super.firstUpdated();
    this.hasTitleSlot =
      this.querySelector('[slot="infographics-heading"]') !== null;
  }

  /**
   * Background color of the panel. Defaults to '' (transparent)
   */
  @property({ type: String, attribute: 'bg-color', reflect: true })
  bgColor: 'dark' | 'light' | 'white' | '' = '';

  render(): TemplateResult {
    const wrapperClasses = {
      'bg-color': this.bgColor,
    };

    return html`
      <div class="infographics-panel ${classMap(wrapperClasses)}">
        ${this.hasTitleSlot
          ? html`<div class="heading">
              <slot name="infographics-heading"></slot>
            </div>`
          : nothing}
        <slot></slot>
      </div>
    `;
  }
}
